import { Header } from "../misc"
import { ContactForm } from "./Forms/ContactUs"
import { Login } from "./Forms/Login"

/**
 * Index Home Page
 */
export default function Home() {
    return (
        <>
          <Header />
            
          <div className='flex flex-col justify-center gap-2 mx-auto md:flex-row'>
  
            <ContactForm />
  
            <div className='border-2' />
  
            <Login />
  
          </div>
        </>
    )
}